import product from "../apis/api";
import {
  CART_ADD_ITEM,
  UPDATE_CART_ITEM,
  CART_REMOVE_ITEM,
  CART_ADD_ITEM_TO_DB,
  CART_REMOVE_ITEM_TO_DB,
  UPDATE_CART_ITEM_TO_DB,
  MOVE_CART_ITEM_TO_DB,
  CART_ADD_ITEM_TO_DB_FAIL,
  CART_REMOVE_ITEM_TO_DB_FAIL,
  UPDATE_CART_ITEM_TO_DB_FAIL,
  MOVE_CART_ITEM_TO_DB_FAIL,
  CART_ADD_ITEM_TO_DB_REQUEST,
  CART_REMOVE_ITEM_TO_DB_REQUEST,
  UPDATE_CART_ITEM_TO_DB_REQUEST,
  MOVE_CART_ITEM_TO_DB_REQUEST,
  CART_SAVE_SHIPPING_ADDRESS,
  CART_SAVE_PAYMENT_METHOD,
  CART_SAVE_USER_SHIPPING_INFO,
} from "./types";

import { configUtil } from "../Utils/apiConfig";
import { errorHandler } from "../Utils/errorHandling";

export const addToCartDB =
  (productId, qty, capacity, color) => async (dispatch, getState) => {
    // After setting the cart items, the send a post request to the server;
    const { userInfo } = getState().userAuth;
    try {
      const { data: cartItem } = await product.get(`/product/${productId}`);

      let specificColorItem;

      const foundCapacity = cartItem.capacity.find((cap) =>
        cap.details.some((detail) => detail.color === color)
      );

      if (foundCapacity) {
        // capacity = foundCapacity.capacity;
        specificColorItem = foundCapacity.details.find(
          (detail) => detail.color === color
        );
      }

      // Check if the item exists, has quantity > 0, and the requested quantity does not exceed available stock
      if (!specificColorItem || specificColorItem.quantity <= 0) {
        console.warn(`${cartItem.productName} Item is out of stock!`);
        dispatch({
          type: CART_ADD_ITEM_TO_DB_FAIL,
          payload: `${cartItem.productName} Item is out of stock!`,
        });
        return; // Stop further execution
      }

      if (qty > specificColorItem.quantity) {
        console.warn(
          `${cartItem.productName} Requested quantity exceeds available stock!`
        );
        dispatch({
          type: CART_ADD_ITEM_TO_DB_FAIL,
          payload: `${cartItem.productName} Requested quantity exceeds available stock!`,
        });
        return; // Stop further execution
      }

      dispatch({ type: CART_ADD_ITEM_TO_DB_REQUEST });

      const response = await product.post(
        `/user/${userInfo._id}/cart`,
        {
          item: {
            productId: cartItem._id,
            name: cartItem.productName,
            description: cartItem.description,
            image: specificColorItem.images[0].url,
            discount: specificColorItem.discount,
            price: specificColorItem.price,
            capacity,
            qty,
            color: color,
            totalSize: Number(specificColorItem.quantity) || 0,
          },
        },
        configUtil(userInfo.token)
      );

      console.log("cartadditiontodb", response.data);

      dispatch({ type: CART_ADD_ITEM_TO_DB, payload: response.data });
      localStorage.setItem("cartItems", JSON.stringify(response.data));
    } catch (error) {
      dispatch({
        type: CART_ADD_ITEM_TO_DB_FAIL,
        payload: errorHandler(error),
      });
    }
  };

export const addToCart =
  (productId, qty, capacity, color) => async (dispatch, getState) => {
    try {
      const { data: cartItem } = await product.get(`/product/${productId}`);

      const foundCapacity = cartItem.capacity.find((cap) =>
        cap.details.some((detail) => detail.color === color)
      );
      let specificColorItem;

      if (foundCapacity) {
        specificColorItem = foundCapacity.details.find(
          (detail) => detail.color === color
        );
      }

      // Check if the item exists, has quantity > 0, and the requested quantity does not exceed available stock
      if (!specificColorItem || specificColorItem.quantity <= 0) {
        console.warn(`${cartItem.productName} Item is out of stock!`);
        dispatch({
          type: CART_ADD_ITEM_TO_DB_FAIL,
          payload: `${cartItem.productName} Item is out of stock!`,
        });
        return; // Stop further execution
      }

      if (qty > specificColorItem.quantity) {
        console.warn(
          `${cartItem.productName} Requested quantity exceeds available stock!`
        );
        dispatch({
          type: CART_ADD_ITEM_TO_DB_FAIL,
          payload: `${cartItem.productName} Requested quantity exceeds available stock!`,
        });
        return; // Stop further execution
      }

      dispatch({
        type: CART_ADD_ITEM,
        payload: {
          productId: cartItem._id,
          name: cartItem.productName,
          description: cartItem.description,
          image: [specificColorItem.images[0].url],
          discount: specificColorItem.discount,
          price: specificColorItem.price,
          capacity,
          qty,
          color: color,
          totalSize: Number(specificColorItem.quantity) || 0,
        },
      });

      localStorage.setItem(
        "cartItems",
        JSON.stringify(getState().cart.cartItems)
      );
    } catch (error) {
      console.log(error);
    }
  };

export const updateCartToDB =
  (productId, qty, capacity, color) => async (dispatch, getState) => {
    const { userInfo } = getState().userAuth;
    try {
      dispatch({ type: UPDATE_CART_ITEM_TO_DB_REQUEST });
      const { data } = await product.patch(
        `/user/${userInfo._id}/update-cart`,
        {
          productId: productId,
          capacity,
          qty: Number(qty),
          color: color,
        },

        configUtil(userInfo.token)
      );
      dispatch({ type: UPDATE_CART_ITEM_TO_DB, payload: data });
      localStorage.setItem("cartItems", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: UPDATE_CART_ITEM_TO_DB_FAIL,
        payload: errorHandler(error),
      });
    }
  };

export const updateCart =
  (productId, qty, capacity, color, cartIndex, description) =>
  async (dispatch, getState) => {
    dispatch({
      type: UPDATE_CART_ITEM,
      payload: {
        productId: productId,
        qty: Number(qty),
        capacity,
        color: color,
        cartIndex: cartIndex,
        description: description,
      },
    });
    localStorage.setItem(
      "cartItems",
      JSON.stringify(getState().cart.cartItems)
    );
  };

export const removeCartItemInDB =
  (productId, capacity, color) => async (dispatch, getState) => {
    const { userInfo } = getState().userAuth;

    try {
      dispatch({ type: CART_REMOVE_ITEM_TO_DB_REQUEST });
      const { data } = await product.patch(
        `/user/${userInfo._id}/remove`,
        {
          productId: productId,
          capacity,
          color: color,
        },
        configUtil(userInfo.token)
      );
      dispatch({ type: CART_REMOVE_ITEM_TO_DB, payload: data });
      localStorage.setItem("cartItems", JSON.stringify(data));
    } catch (error) {
      dispatch({
        type: CART_REMOVE_ITEM_TO_DB_FAIL,
        payload: errorHandler(error),
      });
    }
  };

export const removeItemInCart =
  (productId, capacity, color) => async (dispatch, getState) => {
    dispatch({
      type: CART_REMOVE_ITEM,
      payload: {
        productId: productId,
        capacity,
        color: color,
      },
    });
    localStorage.setItem(
      "cartItems",
      JSON.stringify(getState().cart.cartItems)
    );
  };

export const moveCartToDB = (cartItems) => async (dispatch, getState) => {
  const { userInfo } = getState().userAuth;
  try {
    dispatch({ type: MOVE_CART_ITEM_TO_DB_REQUEST });

    const { data } = await product.post(
      `/user/${userInfo._id}/move-cart-to-db`,
      { cartItems },
      configUtil(userInfo.token)
    );
    dispatch({ type: MOVE_CART_ITEM_TO_DB, payload: data });

    // remove locally stored cart item
    localStorage.setItem("cartItems", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: MOVE_CART_ITEM_TO_DB_FAIL,
      payload: errorHandler(error),
    });
  }
};

export const saveShippingAddress = (data) => async (dispatch) => {
  dispatch({
    type: CART_SAVE_SHIPPING_ADDRESS,
    payload: data,
  });
  localStorage.setItem("shippingAddress", JSON.stringify(data));
};

export const saveUserShippingInfo = (data) => async (dispatch) => {
  dispatch({
    type: CART_SAVE_USER_SHIPPING_INFO,
    payload: data,
  });
  localStorage.setItem("userShippingInfo", JSON.stringify(data));
};

export const savePaymentMethod = (paymentMethod) => async (dispatch) => {
  dispatch({
    type: CART_SAVE_PAYMENT_METHOD,
    payload: paymentMethod,
  });
  localStorage.setItem("paymentMethod", JSON.stringify(paymentMethod));
};
